import { useEffect, useState } from "react";
import useRequest from "./useRequest";
import useAuth from "./useAuth";
import { PaginationResType, PaginationType } from "../types/pagination";
import { DateDataBaseType } from "../types/database";
import { UserRole } from "../types/user";
import { API_ALL, API_FILTE, API_GENERATE, API_URL, BASE_ADMIN } from "../constants/api";
import { AddressesGroupType } from "../types/address";


type GetAllAddressesResType = PaginationResType & {
  data: DataType[];
}
type GenerationResponseType = {
  message: string;
  fileUrl: DateDataBaseType & AddressesGroupType;
}

type DataType = DateDataBaseType & AddressesGroupType;

const useAddressesManager = () => {
  const {user} = useAuth()
  const [addressesList, setAddressesList] = useState<GetAllAddressesResType|null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error|null>(null);
  const {
    error: getAllError,
    isLoading: getAllLoading,
    response: getAllResponse,
    request: getAllRequest
  } = useRequest<GetAllAddressesResType>();

  const {
    error: generationError,
    isLoading: generationLoading,
    response: generationResponse,
    request: requestToGenerateUrl
  } = useRequest<GenerationResponseType>();

  
  if (user?.role !== UserRole.admin) throw new Error("Opération non alloué");


  useEffect(() => {
    setAddressesList(getAllResponse);
  }, [getAllResponse])
  
  useEffect(() => {
    if (generationResponse?.fileUrl) {
      getAllAddresses({page: addressesList ? addressesList.page : 1})
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [generationResponse])

  useEffect(() => {
    setError(getAllError);
  }, [getAllError])

  useEffect(() => {
    setError(generationError);
  }, [generationError])

  useEffect(() => {
    setLoading(getAllLoading??false);
  }, [getAllLoading])


  function getAllAddresses({
    page=1, limit=100, orderby='id', order='DESC'
  }: PaginationType) {
    const searchParams = {
      page: page.toString(),
      limit: limit.toString(),
      orderby: orderby.toString(),
      order: order.toString()
    }
    getAllRequest(BASE_ADMIN, `${API_FILTE}/${API_ALL}`, {secure: true, searchParams});
  }

  function generateUrl(number: number) {
    requestToGenerateUrl(BASE_ADMIN, `${API_URL}/${API_GENERATE}`, {secure: true, method: 'POST'}, {nbrUrl: number});
  }


  return {error, loading, addressesList, getAllAddresses, generateUrl, generationLoading}
}

export default useAddressesManager;